(() => {
  // Revoq does not expose all wording and placement in its form text editor.
  // Keep Stine's approved wording scoped to the Danish withdrawal form.
  const replacements = new Map([
    ['Kontrollér oplysningerne, eller fortsæt uden tilknytning.', 'Tjek dine oplysninger, eller fortsæt uden at tilknytte en ordre.'],
    ['Fortrydelse modtaget', 'Vi har modtaget din anmodning om fortrydelse'],
  ]);

  const updateText = (root) => {
    const header = root.querySelector('.widerruf-form-card__header');
    if (header && !header.querySelector('[data-maison-withdrawal-intro]')) {
      const introduction = document.createElement('p');
      introduction.setAttribute('data-maison-withdrawal-intro', '');
      introduction.textContent = 'Udfyld formularen, og indsend anmodningen om at fortryde dit køb';
      introduction.style.margin = '8px 0 0';
      introduction.style.lineHeight = '1.5';
      header.append(introduction);
    }

    const submitText = root.querySelector('[data-widerruf-submit-text="details"]');
    if (submitText) {
      const label = 'Fortryd aftale';
      if (submitText.textContent.trim() !== label) submitText.textContent = label;
      const button = submitText.closest('button');
      if (button && button.getAttribute('aria-label') !== label) {
        button.setAttribute('aria-label', label);
      }
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement.closest('script, style, textarea')) continue;
      const original = node.nodeValue.trim();
      const replacement = replacements.get(original);
      if (replacement) node.nodeValue = node.nodeValue.replace(original, replacement);
    }
  };

  const observed = new WeakSet();
  document.querySelectorAll('[id^="shopify-block-"][id*="widerrufsbutton_form"]').forEach((block) => {
    const connect = () => {
      block.querySelectorAll('[data-widerruf-inline]').forEach((host) => {
        // Revoq renders the form inside an open shadow root after app startup.
        const root = host.shadowRoot;
        if (!root || observed.has(root)) return;
        observed.add(root);
        updateText(root);
        new MutationObserver(() => updateText(root)).observe(root, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['aria-label'],
        });
      });
    };
    connect();
    new MutationObserver(connect).observe(block, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['data-widerruf-shadow-ready'],
    });
  });
})();
